import { BRAND_RESOURCES } from '@/constants/brand-resources';
import { useSelector, useDispatch } from '../../../react-redux';
import { updataAgentChatUrl as handleUpdataAgentChatUrl } from '../../../reducers/agent';

const useAgentChtUrl = () => {
  const dispatch = useDispatch();
  const agentChatUrl = useSelector(state => state.getIn(['agent', 'agentChatUrl'])) || BRAND_RESOURCES.supportChatUrl;
  const updataAgentChatUrl = data => {
    dispatch(handleUpdataAgentChatUrl(data));
  };

  return { agentChatUrl, updataAgentChatUrl };
};

export default useAgentChtUrl;
